'use strict';

import React from 'react';

import SearchDropdownResult from "./SearchDropdownResult/SearchDropdownResult";

import { OnSchedUtils } from '../../utils';


const SearchDropdown = ({ element, name, label, date, setTimezone, timezoneName, data, setAvailability, value, options, searching, setSearching }) => {
  const [searchedResults, setSearchedResults] = React.useState([]);
  const [searched, setSearched] = React.useState({});
  const [searchInput, setSearchInput] = React.useState('');
  
  const { grouped, groupBy } = options;

  React.useEffect(() => {
    if (data.filter(d => d.timezoneIanna === timezoneName)[0]?.name) {
      setSearchInput(data.filter(d => d.timezoneIanna === timezoneName)[0]?.name);
    }
  }, [data, timezoneName]);

  const search = e => {
    const newSearchedResults = data.filter(r => r.name.toLowerCase().includes(e.target.value.toLowerCase()));
    setSearchedResults(newSearchedResults);
    setSearchInput(e.target.value);
  }

  React.useEffect(() => {
    setSearchedResults(data);
  }, [data]);

  const onfocus = e => {
    setSearching(true);
  }

  return (
    <div className="SearchDropdown" label={OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_timezone')}>
      <input 
        className="SearchDropdownInput onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus" 
        type="text" 
        id="timezoneName-input"
        onChange={search} 
        onFocus={onfocus} 
        value={searchInput} 
        data-timezone-name={searched.value ? searched.value : timezoneName}
      />
      {
        searching &&
        <ul className={`SearchDropdownResults ${searching ? 'onsched-primary-border-color' : 'onsched-border-border-color'} onsched-background-background-color onsched-primary-border-color-hover`}>
          {searchedResults.map((d, i) => <SearchDropdownResult name={d.name} value={d[value]} setInput={setSearchInput} set={setSearched} searching={setSearching} date={date} setAvailability={setAvailability} setTimezone={setTimezone} element={element} key={i} />)}
        </ul>
      }
    </div>
  )
}

export default SearchDropdown
